export * from "./Mc2Table";
